import React from "react";

import {
  CircularProgress,
  Dialog,
  DialogContent,
  Grid,
  Slide,
  IconButton
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { Close } from "@mui/icons-material"; 

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface i_image {
  image: string;
  show: boolean;
  setShow: any;
}

const ImagePreviewModal = ({ image, show, setShow }: i_image) => {
  return (
    <Dialog
      open={show}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => setShow(false)}
      aria-describedby="alert-dialog-slide-description"
      fullWidth={true}
      maxWidth={"sm"}
    >
             <IconButton
        aria-label="close"
        onClick={()=> setShow(false)}
        size="small"
        sx={{
          position: 'absolute',
          right: 2,
          top: 2,
      
        }}
      >
        <Close sx={{color : "gray"}} />
      </IconButton>
      <DialogContent sx={{ p: 4 }}>
        <Grid container justifyContent="center">
          {image === "" ? (
            <CircularProgress color="primary" />
          ) : (
            <img
              src={`data:image/png;base64,${image}`}
              height="300px"
              alt="Preview"
            />
          )}
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default ImagePreviewModal;
